import React from 'react';
import { motion } from 'framer-motion';

export const TrustStrip = () => {
  const stats = [
    { value: "37,000+", label: "Investors currently in the Payne's Education community", mobileVisible: true },
    { value: "40+ Years", label: "Of real market experience behind every lesson", mobileVisible: false },
    { value: "98%", label: "Of reviewers on Reviews.io recommend this program", mobileVisible: true }
  ];

  return (
    <section 
      data-testid="trust-strip"
      className="bg-gray-50 border-y border-gray-100 py-16 px-8 md:px-12"
    >
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-16 text-center">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className={`relative ${!stat.mobileVisible ? 'hidden md:block' : ''}`}
            >
              <p className="stat-value">{stat.value}</p>
              <p className="stat-label mt-2">{stat.label}</p>
              <div className="stat-accent" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
